import React from "react";

const Icons = () => {
  return (
    <section class="icons-container">
      <div class="icons">
        <i class="uil uil-users-alt"></i>
        <h3>5000+</h3>
        <p>Patients</p>
      </div>
      <div class="icons">
        <i class="uil uil-hospital"></i>
        <h3>92%</h3>
        <p>Accuracy</p>
      </div>
      <div class="icons">
        <i class="uil uil-bed"></i>
        <h3>49+</h3>
        <p>Risky Age</p>
      </div>
      <div class="icons">
        <i class="uil uil-brain"></i>
        <h3>15.4%</h3>
        <p>Possible Smokers</p>
      </div>
    </section>
  );
};

export default Icons;
